import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import chevronLeftSvg from "../assets/icon-chevron-left.svg";

interface AuthLayoutProps {
  title: string;
  subtitle?: string;
  icon?: ReactNode;
  backTo?: string;
  // HH-250: when the back-chevron needs side effects (e.g. signOut before
  // routing to /login), callers supply onBack instead of backTo. Takes
  // precedence over backTo when both are provided.
  onBack?: () => void;
  children: ReactNode;
}

export function AuthLayout({ title, subtitle, icon, backTo, onBack, children }: AuthLayoutProps) {
  return (
    <div className="flex items-center justify-center min-h-screen bg-bg-primary relative">
      {onBack ? (
        <button
          type="button"
          onClick={onBack}
          className="absolute top-5 left-5 flex items-center"
          aria-label="Go back"
        >
          <img src={chevronLeftSvg} alt="" width={22} height={22} />
        </button>
      ) : backTo ? (
        <Link
          to={backTo}
          className="absolute top-5 left-5 flex items-center"
          aria-label="Go back"
        >
          <img src={chevronLeftSvg} alt="" width={22} height={22} />
        </Link>
      ) : null}
      <div className="flex flex-col gap-8 items-center justify-center w-[480px]">
        <div className="flex flex-col gap-2 items-center w-[358px]">
          {icon}
          <h2 className="text-2xl font-bold leading-[1.2] text-text-primary text-center w-full">
            {title}
          </h2>
          {subtitle && (
            <p className="text-base font-medium leading-[1.2] text-text-secondary text-center w-full">
              {subtitle}
            </p>
          )}
        </div>
        {children}
      </div>
    </div>
  );
}
